export default __webpack_public_path__ + "static/media/grafema_severe_02.762f3482.jpg";